import { type ReactNode } from 'react'

import { cn } from '@/utils/commonUtil'

import { AnchorTarget } from '../AnchorTarget'

import styles from './Subheader.module.scss'

type Props = {
  children?: ReactNode
  id?: string
  pushDown?: boolean
  pushLeftDisabled?: boolean
}

export const Subheader = ({ children, id, pushDown, pushLeftDisabled }: Props) => (
  <>
    {id && <AnchorTarget id={id} isSticky />}
    <div className={cn(styles.container, { pushDown, pushLeftDisabled, styles })}>{children}</div>
  </>
)
